const locationPages = [
  {
    slug: "kitchen-renovation-hamilton",
    city: "Hamilton",
    service: "Kitchen Renovation",
    title: "Kitchen Renovation in Hamilton",
    seoTitle: "Kitchen Renovation in Hamilton | Xeus Home",
    metaDescription: "Premium kitchen renovations in Hamilton, Ontario. Xeus Home delivers custom cabinetry, countertops, and full kitchen remodels with expert craftsmanship. Free consultation.",
    heroLabel: "Hamilton, Ontario",
    heroTitle: "Premium Kitchen\nRenovation in Hamilton",
    intro: "Your kitchen is the heart of your home. Whether you are looking for a complete layout transformation or a modern refresh of finishes and fixtures, Xeus Home delivers kitchen renovations in Hamilton that combine exceptional design with lasting craftsmanship.",
    sections: [
      {
        heading: "What We Do",
        text: "From concept to completion, our team manages every detail of your kitchen renovation. We work with you to design a space that fits your lifestyle, your aesthetic, and your budget — then we build it to the highest standard.",
        items: [
          "Custom cabinetry design and installation",
          "Countertop selection and fabrication (quartz, granite, marble)",
          "Backsplash tile work and feature walls",
          "Lighting design including pot lights and pendants",
          "Plumbing and electrical upgrades",
          "Flooring installation (hardwood, tile, luxury vinyl)",
          "Appliance integration and layout optimization"
        ]
      },
      {
        heading: "Why Hamilton Homeowners Choose Xeus Home",
        text: "We have completed numerous kitchen renovations across Hamilton, from Dundas to Stoney Creek. Our clients choose us because we combine premium craftsmanship with transparent pricing and clear communication throughout the project.",
        items: [
          "Dedicated project manager from start to finish",
          "Fully licensed, insured, and WSIB compliant",
          "Detailed written quotes with no hidden costs",
          "All permits handled on your behalf",
          "Trusted network of top-tier skilled trades"
        ]
      }
    ],
    ctaText: "Ready to renovate your kitchen in Hamilton?",
    ctaButton: "Get a Free Consultation"
  },
  {
    slug: "bathroom-renovation-burlington",
    city: "Burlington",
    service: "Bathroom Renovation",
    title: "Bathroom Renovation in Burlington",
    seoTitle: "Bathroom Renovation in Burlington | Xeus Home",
    metaDescription: "Transform your bathroom with Xeus Home in Burlington, Ontario. Custom vanities, tile work, glass showers, and full bathroom remodels. Free consultation.",
    heroLabel: "Burlington, Ontario",
    heroTitle: "Luxury Bathroom\nRenovation in Burlington",
    intro: "A well-designed bathroom elevates your daily routine and adds significant value to your home. Xeus Home specializes in bathroom renovations in Burlington that transform ordinary spaces into something extraordinary — from sleek modern ensuites to spa-inspired retreats.",
    sections: [
      {
        heading: "Our Bathroom Renovation Services",
        text: "We handle every aspect of your bathroom renovation, ensuring a seamless experience from design through to final walkthrough.",
        items: [
          "Custom vanity design with premium finishes",
          "Glass shower enclosure installation",
          "Feature tile walls and floor-to-ceiling tile work",
          "Heated flooring systems",
          "Plumbing relocation and fixture upgrades",
          "Lighting design and ventilation improvements",
          "Accessibility modifications and walk-in showers"
        ]
      },
      {
        heading: "Why Burlington Homeowners Trust Us",
        text: "From Aldershot to Burlington's lakeside neighbourhoods, we have delivered bathroom transformations that exceed expectations. Our attention to detail in tile alignment, grout work, and fixture placement is what sets us apart.",
        items: [
          "Expert tile work that photographs beautifully and lasts for decades",
          "Fully licensed, insured, and WSIB compliant",
          "Transparent pricing with detailed written quotes",
          "Municipal permits managed on your behalf",
          "Dedicated project coordination from day one"
        ]
      }
    ],
    ctaText: "Ready to transform your bathroom in Burlington?",
    ctaButton: "Get a Free Consultation"
  },
  {
    slug: "home-renovation-oakville",
    city: "Oakville",
    service: "Home Renovation",
    title: "Home Renovation in Oakville",
    seoTitle: "Home Renovation in Oakville | Xeus Home",
    metaDescription: "Full home renovations in Oakville, Ontario. Xeus Home delivers premium kitchen, bathroom, basement, and whole-home remodels. Free consultation.",
    heroLabel: "Oakville, Ontario",
    heroTitle: "Full Home\nRenovation in Oakville",
    intro: "Oakville homeowners expect quality — and that is exactly what Xeus Home delivers. Whether you are undertaking a full home renovation or transforming a single floor, our team manages the entire process with precision, transparency, and premium craftsmanship.",
    sections: [
      {
        heading: "Comprehensive Renovation Services",
        text: "A full home renovation touches every system in your house. Our team coordinates all trades seamlessly so you get a cohesive, high-quality result.",
        items: [
          "Complete kitchen and bathroom renovations",
          "Basement finishing and conversions",
          "Open-concept layout transformations",
          "Structural modifications and additions",
          "Electrical and plumbing system upgrades",
          "Custom millwork, trim, and built-ins",
          "Interior and exterior finishing"
        ]
      },
      {
        heading: "Why Oakville Homeowners Choose Us",
        text: "We understand the standards Oakville homeowners hold for their properties. Our portfolio includes projects across Oakville's finest neighbourhoods, each delivered with the care and quality our clients expect.",
        items: [
          "End-to-end project management by our core team",
          "Fully licensed, insured, and WSIB compliant",
          "Premium materials and finishes as standard",
          "All permits and inspections handled for you",
          "Clear timelines and honest communication"
        ]
      }
    ],
    ctaText: "Ready to renovate your Oakville home?",
    ctaButton: "Get a Free Consultation"
  },
  {
    slug: "home-renovation-mississauga",
    city: "Mississauga",
    service: "Home Renovation",
    title: "Home Renovation in Mississauga",
    seoTitle: "Home Renovation in Mississauga | Xeus Home",
    metaDescription: "Premium home renovation services in Mississauga, Ontario. Kitchens, bathrooms, basements, and full home remodels by Xeus Home. Free consultation.",
    heroLabel: "Mississauga, Ontario",
    heroTitle: "Premium Home\nRenovation in Mississauga",
    intro: "From Port Credit to Streetsville, Mississauga homeowners trust Xeus Home for renovations that are built to last and designed to impress. We bring the same premium standard to every project, whether it is a kitchen refresh or a full home transformation.",
    sections: [
      {
        heading: "What We Offer in Mississauga",
        text: "Our team delivers comprehensive renovation services tailored to your home, your vision, and your budget.",
        items: [
          "Kitchen renovations with custom cabinetry and stone countertops",
          "Bathroom remodels with premium tile and fixture work",
          "Basement finishing for additional living space",
          "Main floor open-concept conversions",
          "Electrical, plumbing, and HVAC upgrades",
          "Interior design consultation and material selection",
          "Permit acquisition and inspection management"
        ]
      },
      {
        heading: "Trusted in Mississauga",
        text: "We have a proven track record of delivering renovations across Mississauga that meet the highest standards of quality and professionalism.",
        items: [
          "Dedicated project manager throughout your renovation",
          "Fully licensed, insured, and WSIB compliant",
          "Itemized quotes with no surprises",
          "Expert coordination of all trades",
          "Post-project warranty on workmanship"
        ]
      }
    ],
    ctaText: "Ready to start your renovation in Mississauga?",
    ctaButton: "Get a Free Consultation"
  },
  {
    slug: "basement-renovation-gta",
    city: "the GTA",
    service: "Basement Renovation",
    title: "Basement Renovation in the GTA",
    seoTitle: "Basement Renovation in the GTA | Xeus Home",
    metaDescription: "Basement finishing and renovation across the Greater Toronto Area. Xeus Home creates functional, beautiful basement spaces. Free consultation.",
    heroLabel: "Greater Toronto Area",
    heroTitle: "Basement Renovation\nAcross the GTA",
    intro: "Your basement is one of the most underutilized spaces in your home. Xeus Home transforms unfinished basements across the Greater Toronto Area into fully functional living spaces — from home offices and guest suites to entertainment areas and rental units.",
    sections: [
      {
        heading: "Basement Renovation Services",
        text: "We handle every phase of your basement renovation, from waterproofing and structural work through to the final finishing touches.",
        items: [
          "Full basement finishing and layout design",
          "Moisture management and waterproofing",
          "Bathroom and kitchenette additions",
          "Egress window installation for legal bedrooms",
          "Electrical panel upgrades and lighting design",
          "Flooring installation (engineered hardwood, tile, LVP)",
          "Custom built-ins and storage solutions"
        ]
      },
      {
        heading: "Serving the Entire GTA",
        text: "From Hamilton to Toronto, Burlington to Mississauga, our team delivers basement renovations across the Greater Toronto Area with consistent quality and professionalism.",
        items: [
          "Experienced with municipal building codes across the GTA",
          "Fully licensed, insured, and WSIB compliant",
          "Permit acquisition and all inspections managed",
          "Detailed written contracts with clear timelines",
          "Dedicated project management from start to finish"
        ]
      }
    ],
    ctaText: "Ready to unlock your basement's potential?",
    ctaButton: "Get a Free Consultation"
  },
  {
    slug: "renovation-contractor-st-catharines",
    city: "St. Catharines",
    service: "General Renovation",
    title: "Renovation Contractor in St. Catharines",
    seoTitle: "Renovation Contractor in St. Catharines | Xeus Home",
    metaDescription: "Trusted renovation contractor in St. Catharines, Ontario. Xeus Home specializes in kitchens, bathrooms, basements, and full home renovations. Free consultation.",
    heroLabel: "St. Catharines, Ontario",
    heroTitle: "Your Trusted Renovation\nContractor in St. Catharines",
    intro: "Finding a reliable renovation contractor in St. Catharines should not be a gamble. Xeus Home brings premium craftsmanship and transparent project management to homeowners across the Niagara Region — delivering kitchens, bathrooms, basements, and full home renovations that exceed expectations.",
    sections: [
      {
        heading: "Our Renovation Services",
        text: "No matter the scope of your project, our team delivers a seamless renovation experience from first consultation to final walkthrough.",
        items: [
          "Kitchen renovations and custom cabinetry",
          "Bathroom remodels and spa-inspired designs",
          "Basement finishing and conversions",
          "Full home renovations and additions",
          "Structural modifications and open-concept layouts",
          "Electrical, plumbing, and HVAC coordination",
          "Permit management and municipal inspections"
        ]
      },
      {
        heading: "Why St. Catharines Homeowners Trust Us",
        text: "We have built lasting relationships with homeowners across the Niagara Region through honest communication, quality workmanship, and a commitment to doing the job right.",
        items: [
          "Fully licensed, insured, and WSIB compliant",
          "Transparent, itemized pricing with no hidden fees",
          "All permits and inspections handled on your behalf",
          "Expert coordination of skilled tradespeople",
          "Post-completion warranty on all workmanship"
        ]
      }
    ],
    ctaText: "Ready to renovate in St. Catharines?",
    ctaButton: "Get a Free Consultation"
  }
];

export default locationPages;
